import { useState } from 'react';
import moment from 'moment';
import { TimesheetsTable } from 'src/components/TimeSheet/TimesheetsTable';
import { TimesheetsTableHeader } from 'src/components/TimeSheet/TimesheetsTableHeader';
import { TimesheetsTabStyles } from 'src/styles/TimesheetsTabStyles';
import { WeekStartDateContext } from '../context/weekStartDate';
import { TimeSheetsProvider } from 'src/context/TimeSheet/TimesheetsContext';

export const Timesheets = () => {
  const currentWeekStartDate = moment().startOf('isoWeek').toDate();
  const [weekStartDate, setWeekStartDate] =
    useState<Date>(currentWeekStartDate);
  const [anyPopupsOpen, setAnyPopupsOpen] = useState<boolean>(false);

  return (
    <>
      <TimesheetsTabStyles />
      <div>
        <WeekStartDateContext.Provider value={weekStartDate}>
          <TimeSheetsProvider>
            <TimesheetsTableHeader
              setWeekStartDate={setWeekStartDate}
              setAnyPopupsOpen={setAnyPopupsOpen}
            />
            <TimesheetsTable
              anyPopupsOpen={anyPopupsOpen}
              setAnyPopupsOpen={setAnyPopupsOpen}
            />
          </TimeSheetsProvider>
        </WeekStartDateContext.Provider>
      </div>
    </>
  );
};
